module.exports = __webpack_public_path__ + "static/img/doc_aide_fuites-refrigeration.b68eb288.png";